import React from 'react';
import { Button, Flex, Image, Text } from '@chakra-ui/react';
import { EmptyPageWithLogo } from '@/src/app/_components/empty-page-with-logo';

export const DashboardErrorPage: React.FC<{
  title: string;
  subTitle?: string;
  button: { text: string; onClick: () => void };
}> = ({ button, title, subTitle }) => {
  return (
    <EmptyPageWithLogo>
      <Flex alignItems={'center'} flexDirection={'column'} maxW={'680px'}>
        <Image alt={'Livecycle'} h={'128px'} w={'146px'} src={'/warning-icon.svg'} mb={12} />
        <Text textStyle={'headline-lg'} textAlign={'center'} mb={2}>
          {title}
        </Text>
        <Text textStyle={'body-lg'} textAlign={'center'} mb={10}>
          {subTitle}
        </Text>
        <Button h={12} w={'max-content'} onClick={button.onClick}>
          {button.text}
        </Button>
      </Flex>
    </EmptyPageWithLogo>
  );
};
